import React from "react";
import {css} from "@emotion/react";

import {mb, mt, onDesktop, p} from "@pg-design/helpers-css";
import {Radio} from "@pg-design/radio-module";

import {SortFilterFooter} from "./SortFiltersFooter";

interface ISortOption<TValue> {
    label: string;
    value: TValue;
}

interface IProps<TValue> {
    currentValue: TValue | null;
    setCurrentValue: (value: TValue) => void;
    sortOptions: ISortOption<TValue>[];
    onClear: () => void;
    onSave: () => void;
}

export const SortOptions = <TValue extends number | string>(props: IProps<TValue>) => {
    return (
        <div css={sortHolder}>
            <div css={sortOptionsHolder}>
                {props.sortOptions.map((sortOption) => {
                    const sortOptionId = sortOption.value.toString();
                    const isActive = sortOption.value === props.currentValue;

                    return (
                        <Radio
                            key={sortOptionId}
                            id={sortOptionId}
                            name={sortOption.label}
                            labelContent={sortOption.label}
                            isActive={isActive}
                            value={sortOption.value}
                            onChange={() => {
                                props.setCurrentValue(sortOption.value);
                            }}
                            css={mb(2)}
                        />
                    );
                })}
            </div>
            <SortFilterFooter handleClear={props.onClear} handleSave={props.onSave} />
        </div>
    );
};

const sortHolder = css`
    height: calc(100vh - 6rem);
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ${mt(2)};
    ${p(0, 3, 2, 3)};

    ${onDesktop(css`
        height: unset;
        display: block;
        padding: 0;
    `)};
`;

const sortOptionsHolder = css`
    display: flex;
    flex-direction: column;
    align-items: start;
    flex-shrink: 0;
    flex-grow: 0;
`;
import React from "react";
import {css} from "@emotion/react";

import {mb, mt, onDesktop, p} from "@pg-design/helpers-css";
import {Radio} from "@pg-design/radio-module";

import {SortFilterFooter} from "./SortFiltersFooter";

interface ISortOption<TValue> {
    label: string;
    value: TValue;
}

interface IProps<TValue> {
    currentValue: TValue | null;
    setCurrentValue: (value: TValue) => void;
    sortOptions: ISortOption<TValue>[];
    onClear: () => void;
    onSave: () => void;
}

export const SortOptions = <TValue extends number | string>(props: IProps<TValue>) => {
    return (
        <div css={sortHolder}>
            <div css={sortOptionsHolder}>
                {props.sortOptions.map((sortOption) => {
                    const sortOptionId = sortOption.value.toString();
                    const isActive = sortOption.value === props.currentValue;

                    return (
                        <Radio
                            key={sortOptionId}
                            id={sortOptionId}
                            name={sortOption.label}
                            labelContent={sortOption.label}
                            isActive={isActive}
                            value={sortOption.value}
                            onChange={() => {
                                props.setCurrentValue(sortOption.value);
                            }}
                            css={mb(2)}
                        />
                    );
                })}
            </div>
            <SortFilterFooter handleClear={props.onClear} handleSave={props.onSave} />
        </div>
    );
};

const sortHolder = css`
    height: calc(100vh - 6rem);
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    ${mt(2)};
    ${p(0, 3, 2, 3)};

    ${onDesktop(css`
        height: unset;
        display: block;
        padding: 0;
    `)};
`;

const sortOptionsHolder = css`
    display: flex;
    flex-direction: column;
    align-items: start;
    flex-shrink: 0;
    flex-grow: 0;
`;
